import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ExcepcionesComponent } from 'app/utilerias/excepciones/excepciones.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'environments/environment';
import { AppState } from 'app/store/app.states';
import { Store } from '@ngrx/store';
import { MostrarExcepcion, MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { CoalService } from 'app/services/coal.service';
import { formatDate } from '@angular/common';
import { sparrowService } from 'app/services/sparrowService';

@Component({
  selector: 'app-success-facturacion',
  templateUrl: './success-facturacion.component.html',
  styleUrls: ['./success-facturacion.component.scss'],
})
export class SuccessFacturacionComponent implements OnInit {
    idFactura: number;
    visibleError:boolean = true;
    detalle: any = [];
    dataFactura: any;

    constructor(
        private dialogRef: MatDialogRef<SuccessFacturacionComponent>,
        private route: Router,
        @Inject(MAT_DIALOG_DATA) public data: any,

        public dialog: MatDialog,
		private readonly store: Store<AppState>,
		private srvcoal: CoalService,
        private sparroService : sparrowService
    ) { }

    ngOnInit(): void {
        console.log('SuccessFacturacionComponent', this.data.data);
        console.log('SuccessFacturacionComponent', this.data.data.clave);
        this.idFactura = this.data.data.clave;
        this.dataFactura = this.data.data;
        this.detalle = JSON.parse( this.data.error.data.detalle );

    }

    cerrar(): void {
        this.dialogRef.close();
    }

    accionar(){
        this.visibleError = !this.visibleError;
    }

    formatoOracion( mensaje){
        let nuevoMensaje = mensaje.charAt(0).toUpperCase() + mensaje.slice(1).replace(/[A-Z]/g, ' $&').toLowerCase();
        return nuevoMensaje;
    }

    acentuarPalabras(cadena) {
        let mapaAcentos = {
            'á': 'a',
            'é': 'e',
            'í': 'i',
            'ó': 'o',
            'ú': 'u',
            'Á': 'A',
            'É': 'E',
            'Í': 'I',
            'Ó': 'O',
            'Ú': 'U'
        };

        let palabras = cadena.split(' ');
        for (let i = 0; i < palabras.length; i++) {
            let palabra = palabras[i];
            let nuevaPalabra = '';
            for (let j = 0; j < palabra.length; j++) {
                let letra = palabra.charAt(j);
                if (mapaAcentos[letra]) {
                    nuevaPalabra += mapaAcentos[letra];
                } else {
                    nuevaPalabra += letra;
                }
            }
            palabras[i] = nuevaPalabra;
        }

        return palabras.join(' ');
    }

    convertirBooleano(valor: boolean): string {
        return valor ? "Si" : "No";
    }

    dowload(url) {
		this.store.dispatch(MostrarSpinner());
		if (url == 'xml') {
			this.descargarXML();
		} else {
			this.descargarFactura();
		}
	}

    enviarCorreo() {
        localStorage.setItem('enviarCorreoNuevaFactura', 'true');
        this.dialogRef.close();
    }

    descargarXML() {
		let factura_response;
		let data = {
			clave: this.idFactura
		}
		this.srvcoal.postService("operacion/GetReporteFacturaXML", data).subscribe(
			(response: any) => {
				// //console.log(response);
				let Dt = new Date();
				let stDT = Dt.toDateString();
				factura_response = response.recordsets[0][0].cfdi_Comprobante;

				var fileToExport = new Blob([factura_response], { type: "text/xml" });
				var a = document.createElement("a");
				a.href = URL.createObjectURL(fileToExport);
				a.target = "_blank";
				a.download = `${''}-${stDT}.xml`
				a.click();
				this.store.dispatch(OcultarSpinner());
			}, (error: any) => {
				this.store.dispatch(OcultarSpinner());
				this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
			});
	}

    descargarFactura(){
        switch(this.dataFactura.tipofactura){
            case 1 :
                this.facturaF(this.dataFactura);
            break;
            case 2 :
                this.facturaF(this.dataFactura);
            break;
            case 3:
                this.facturaC(this.dataFactura);
            break;
            default :
                this.facturaF(this.dataFactura);
            break;
        }

    }

    facturaC(factura){
        this.store.dispatch(MostrarSpinner());
        var body = {idfactura : factura.clave}
        this.srvcoal.postService(`catalogo/selReporteComplementos`, body).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
            } else if (res.excepcion) {
                this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }))
            } else {
                let body = {
                    logo : 'https://img.freepik.com/vector-premium/icono-empresa-ilustracion-elemento-simple-diseno-simbolo-concepto-empresa-puede-utilizar-web-movil_159242-7784.jpg?w=2000',
                    emisor : {
                        nombre : res.recordsets[0][0].fullname,
                        rfc : res.recordsets[0][0].rfc,
                        direccion : res.recordsets[0][0].direccion,
                        lugar_emision : res.recordsets[0][0].LugarEmosion,
                    },
                    receptor : {
                        nombre : res.recordsets[1][0].nombreRazonSocial,
                        rfc : res.recordsets[1][0].rfc,
                        direccion : res.recordsets[1][0].direccion
                    },
                    productos : res.recordsets[3][0],
                    tproductos : res.recordsets[4][0].total,
                    pagos : res.recordsets[5],
                    DocsRel : res.recordsets[6],
                    footer : {
                        NoCertificado : res.recordsets[7][0].NoCertificado,
                        cadena_original : res.recordsets[7][0].SelloDgitalSAT,
                        sello_emisor : res.recordsets[7][0].Sello,
                        sello_sat : res.recordsets[7][0].SelloSAT,
                        version :res.recordsets[7][0].Version,
                        emisor_cert : res.recordsets[7][0].Certificado,
                        fecha_emit : res.recordsets[7][0].FechaTimbrado,
                        sat_cret : res.recordsets[7][0].NoCertificado,
                        pac : "Lorem",
                        qr : res.recordsets[7][0].SelloDgitalSAT
                    }
                };
                var name = res.recordsets[7][0]?.uuid + " " + formatDate(new Date(), 'dd/MM/yyyy', 'en-GB');
                this.sparroService.getReport("reportes/CallFeatureNew",body,name);
            };

            this.store.dispatch(OcultarSpinner())

        }, (error: any) => {
            this.store.dispatch(OcultarSpinner());
            this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
        });
    }
    facturaF(factura){
        this.store.dispatch(MostrarSpinner());
        //this.spinner = true;
        var factura_response;
        let data = {
            clave : factura.clave
        }
        this.srvcoal.postService("operacion/GetReporteFactura",data).subscribe(
        (response: any) => {
            factura_response = response.recordsets;
            var name = factura_response[0][0].uuid + " " + formatDate(new Date(), 'dd/MM/yyyy', 'en-GB');;
            this.sparroService.getReport("reportes/SelPdf",factura_response,name);
        });
    }

}
